import React from 'react';
import { Dialog, DialogContent, makeStyles } from '@material-ui/core';
import { BottomTransition, ModalWidthValues } from '../helpers';
import { dimensions } from '../../../theme';

const useStyles = makeStyles({
  dialogContent: {
    marginTop: dimensions.bottomDrawerTopSpace,
    borderRadius: '10px 10px 0 0',
  },
  backdrop: {
    background: 'rgba(0, 0, 0, 0.5)',
  },
});

export type BottomModalProps = {
  /** The optional test id which will identify the modal on the test */
  testid?: string;
  /** The modal's content */
  children: React.ReactNode;
  /** Whether the modal is open or closed */
  isOpen: boolean;
  /** The possible widths the modal can have */
  typeMaxWidth?: ModalWidthValues;
  /** Called when the modal itself triggers the close logic */
  handleClose?: () => void;
  /** Called when the backdrop is clicked */
  onBackdropClick?: () => void;
};

const BottomModal = ({
  testid,
  children,
  isOpen,
  typeMaxWidth,
  onBackdropClick,
}: BottomModalProps): JSX.Element => {
  const classes = useStyles();
  return (
    <Dialog
      key={testid}
      data-testid={testid}
      PaperProps={{
        className: classes.dialogContent,
      }}
      BackdropProps={{
        className: classes.backdrop,
      }}
      maxWidth={typeMaxWidth}
      fullScreen
      open={isOpen}
      onClick={onBackdropClick}
      TransitionComponent={BottomTransition}
    >
      <DialogContent
        data-testid="dialog-content"
        onClick={(e: React.MouseEvent): void => e.stopPropagation()}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default BottomModal;
